import api from './../../lib/api';

export const SMS_BEACONS_LIST_LOAD = 'SMS_BEACONS_LIST_LOAD';
export const SMS_BEACON_CREATE = 'SMS_BEACON_CREATE';
export const SMS_BEACON_UPDATE = 'SMS_BEACON_UPDATE';
export const SMS_BEACON_DELETE = 'SMS_BEACON_DELETE';

const SMS_BEACONS_LIST_LOADING_CHANGE = 'SMS_BEACONS_LIST_LOADING_CHANGE';
const SMS_BEACONS_LIST_CHANGE = 'SMS_BEACONS_LIST_CHANGE';
const SMS_BEACONS_CHANGE = 'SMS_BEACONS_CHANGE';
const SMS_BEACON_LOADING_CHANGE = 'SMS_BEACON_LOADING_CHANGE';
const SMS_BEACON_ERRORS_CHANGE = 'SMS_BEACON_ERRORS_CHANGE';
const SMS_BEACON_SAVING_CHANGE = 'SMS_BEACON_SAVING_CHANGE';
const SMS_BEACON_DELETING_CHANGE = 'SMS_BEACON_DELETING_CHANGE';

const state = {
    sms_beacons_list: [],
    sms_beacon: {},
    sms_beacon_empty: {
        phone: '',
        sms_provider_id: null,
        sms_template_id: null,
        periodicity: 720,
        limit: 100,
        counter: 0,
        is_work: false,
    },
    sms_beacons_list_loading: false,
    sms_beacon_loading: false,
    sms_beacon_saving: false,
    sms_beacon_errors: {},
    sms_beacon_deleting: false,
};

const actions = {
    /**
     * Загружает список маячков по ключу бизнес-процесса
     */
    [SMS_BEACONS_LIST_LOAD]({ commit, state }, bpKey) {
        return api.list(
            'bpm.bp.key',
            `${bpKey}/sms-beacons`,
            {},
            state,
            commit,
            SMS_BEACONS_LIST_LOADING_CHANGE,
            SMS_BEACONS_LIST_CHANGE
        );
    },

    /**
     * Создает новый маячок
     */
    [SMS_BEACON_CREATE]({ commit, state }, { bpKey, data }) {
        return api.create(
            'bpm.bp.key',
            `${bpKey}/sms-beacons`,
            data,
            state,
            commit,
            SMS_BEACON_LOADING_CHANGE,
            SMS_BEACONS_CHANGE,
            SMS_BEACON_ERRORS_CHANGE
        );
    },

    /**
     * Обновляет маячок
     */
    [SMS_BEACON_UPDATE]({ commit, state }, { bpKey, id, data }) {
        return api.update(
            'bpm.bp.key',
            `${bpKey}/sms-beacons/${id}`,
            data,
            state,
            commit,
            SMS_BEACON_SAVING_CHANGE,
            SMS_BEACONS_CHANGE,
            SMS_BEACON_ERRORS_CHANGE
        );
    },

    /**
     * Удаляет маячок
     */
    [SMS_BEACON_DELETE]({ commit, state }, { bpKey, id }) {
        commit(SMS_BEACON_DELETING_CHANGE, true);
        return api.delete(
            'bpm.bp.key',
            `${bpKey}/sms-beacons/${id}`,
            state,
            commit,
            SMS_BEACONS_CHANGE
        ).finally(() => {
            commit(SMS_BEACON_DELETING_CHANGE, false);
        });
    },
};

const mutations = {
    [SMS_BEACONS_LIST_LOADING_CHANGE](state, data) {
        state.sms_beacons_list_loading = data;
    },

    [SMS_BEACONS_LIST_CHANGE](state, data) {
        if (data?.data) {
            state.sms_beacons_list = data.data;
        } else {
            state.sms_beacons_list = [];
        }
    },

    [SMS_BEACONS_CHANGE](state, data) {
        if (data?.data) {
            state.sms_beacon = data.data;
        } else {
            state.sms_beacon = _.cloneDeep(state.sms_beacon_empty);
        }
    },

    [SMS_BEACON_LOADING_CHANGE](state, data) {
        state.sms_beacon_loading = data;
    },

    [SMS_BEACON_SAVING_CHANGE](state, data) {
        state.sms_beacon_saving = data;
    },

    [SMS_BEACON_ERRORS_CHANGE](state, data) {
        state.sms_beacon_errors = data;
    },

    [SMS_BEACON_DELETING_CHANGE](state, data) {
        state.sms_beacon_deleting = data;
    },
};

export default {
    state,
    actions,
    mutations
};